var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartTeal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5603 23.7208L11.8103 19.7625C8.6836 16.4538 7.92054 11.5598 9.8916 7.45623V7.45623C11.2703 4.41828 14.0688 2.2643 17.3585 1.70914C20.6481 1.15397 23.9985 2.27024 26.2978 4.68748L29.1249 7.62915L31.952 4.68748C34.2514 2.27118 37.6012 1.15553 40.8902 1.71065C44.1792 2.26578 46.9773 4.41909 48.3562 7.45623V7.45623C50.3272 11.5598 49.5642 16.4538 46.4374 19.7625L29.1249 37.5L24.7937 33.0604",
    stroke: "#008995",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 31.2501L20.1104 28.6355C20.8292 28.0964 21.7382 27.8769 22.6237 28.0287C23.5093 28.1804 24.2934 28.6899 24.7917 29.4376V29.4376C25.523 30.5352 25.523 31.9649 24.7917 33.0626L21.3646 38.2022C20.3115 39.7808 18.8041 41.0027 17.0417 41.7063L11.9375 43.7501V48.4376",
    stroke: "#008995",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0478 22.1228C0.345731 27.9957 2.5624 40.5957 2.5624 48.4374",
    stroke: "#008995",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartTeal);
export default __webpack_public_path__ + "static/media/heart-teal.36cc27c5c2582870285b6fd9283a41d3.svg";
export { ForwardRef as ReactComponent };